import {atom} from 'jotai';
import {atomFamily, atomWithStorage} from 'jotai/utils';
import {MYFC_INITIAL_COORD, UPLUSE_INITIAL_COORD} from '@/map/constants';
import {AnalysisTabType, AreaAnalyticsFilter, MobileMapAgent} from '@/map/enums';
import {AddressSearchHistoryItem, KodataNearbyStoreItem, MobileAnalysisItem} from '../@types';

export const mapAgentTypeAtom = atom<MobileMapAgent | null>(null);

export const mapMobileCenterAtom = atomFamily((agent: MobileMapAgent) =>
  atom<naver.maps.Coord>(agent === MobileMapAgent.lgup ? UPLUSE_INITIAL_COORD : MYFC_INITIAL_COORD)
);

export const mobileAnalysisPointAtom = atom<MobileAnalysisItem | null>(null);

export const mobileBottomSheetTopAtom = atom<number>(0);

// 바텀시트 완전 확장 시의 top 위치(=시트 clientHeight). 외부 버튼에서 확장 트리거용.
export const mobileBottomSheetFullTopAtom = atom<number>(0);

// 시트가 완전히 펼쳐져 본문이 실제로 스크롤되는 상태인지. BottomSheet가 overflow 판정에
// 쓰는 값을 그대로 공유해, 자식 콘텐츠가 같은 기준으로 스크롤 여부를 알 수 있게 한다.
export const mobileBottomSheetExpandedAtom = atom<boolean>(false);

export const mobileAnalysisActiveTabAtom = atom<AnalysisTabType>(AnalysisTabType.basic);

export const selectedNearbyInfoItemCardAtom = atom<{
  type: AreaAnalyticsFilter;
  item: any;
} | null>(null);

export const selectedNearbyStoreItemCardAtom = atom<{
  items: KodataNearbyStoreItem[];
  index: number;
} | null>(null);

export const selectedNearbyStoreCategoryAtom = atom<string | null>(null);

export const mobileAddressSearchHistoryAtom = atomWithStorage<Omit<AddressSearchHistoryItem, 'keyword'>[]>(
  'mobile-map/addr-search/history-list',
  []
);

// 모바일 지도 내부에서만 쓰는 토스트 (단일)
// null이면 토스트 미노출, 문자열이 있으면 토스트 보여줌
export const internalToastAtom = atom<string | null>(null);
